import * as React from 'react';
import {MainStageEvent} from "data/MainStageData";
import {observer} from "mobx-react";
import * as moment from "moment-timezone";

import './MainStageEventWidget.pcss';
import {SVG} from "../widgets/SVG";

interface IMainStageEventWidget_Props {
  event:MainStageEvent;
  firstListing:boolean;
  onClick:()=>void;
}

@observer
export class MainStageEventWidget extends React.Component<IMainStageEventWidget_Props> {

  render() {

    const start = moment(this.props.event.presentationStartTS);
    const end = moment(this.props.event.qaEndTS);

    let statusLine = <h2>{this.props.event.status}</h2>;
    if(this.props.firstListing) {
      if(this.props.event.isLive) {
        statusLine = <h2><span className={"live"}>LIVE</span> ON THE MAINSTAGE</h2>;
      } else {
        statusLine = <h2>MAINSTAGE {this.props.event.status}</h2>;
      }
    }

    return (
      <div className={"mainstage-event"}>
        {statusLine}
        <div className={"icon"} aria-hidden={true}>
          <SVG src={this.props.event.icon} title={this.props.event.navTitle} fill={this.props.event.isLive?'#ed5a5a':'#7d83b3'} />
        </div>
        <div className={"info"}>
          <h3 className={'level3'}>{this.props.event.navTitle}</h3>
          <h4 className={'level4'}>{`${start.tz(moment.tz.guess()).format('MMM').toUpperCase()}${start.tz(moment.tz.guess()).format(' D [at] h:mm')}-${end.tz(moment.tz.guess()).format('h:mm')}${end.tz(moment.tz.guess()).format('a').substring(0,1)}`}</h4>
        </div>
      </div>
    );
  }
}
